export default __webpack_public_path__ + "static/media/first_aid.698b40e3.svg";